import { Grid } from "@mui/material";
import React from "react";
import AppLayout from "../SideBar";
import SendMedication from "../../components/ui/Doctor/Appointments/SendMedicationNew";

const DoctorAppointmentSendMedication = () => {

  return (
    <Grid container spacing={0}>
      <AppLayout>
        <SendMedication />
      </AppLayout>
    </Grid>
  )
}

export default DoctorAppointmentSendMedication;